import React from 'react';
const bonuses = [{
  num: '1',
  value: '47€',
  title: 'Der 30-Tage Reset-Plan',
  desc: 'Ihr klarer Fahrplan für die ersten 30 Tage. Kein Rätseln. Kein Improvisieren.'
}, {
  num: '2',
  value: '27€',
  title: 'Die 12-Wochen-Einkaufsliste',
  desc: '12 Wochen fertige Einkaufslisten — damit Ihre Küche für Ihre Gesundheit arbeitet.'
}, {
  num: '3',
  value: '37€',
  title: '15-Minuten-Rezepte',
  desc: '45 ultraschnelle Rezepte für stressige Tage — weil Zeitmangel keine Ausrede sein sollte.'
}, {
  num: '4',
  value: '37€',
  title: 'Das Dessertbuch ohne Reue',
  desc: '40 köstliche Desserts ohne Zucker. Weil gesund sein nicht bedeutet, zu verzichten.'
}, {
  num: '5',
  value: '37€',
  title: 'Der Wochenplaner',
  desc: 'Ihre Ernährungswoche in 15 Minuten organisiert. Kein Chaos. Nur Klarheit.'
}];
export function BonusSection() {
  return <section className="py-8 sm:py-12 px-4 bg-brand-olive-dark text-white" data-id="element-28">
      <div className="max-w-2xl mx-auto" data-id="element-29">
        <div className="text-center mb-6 sm:mb-8" data-id="element-30">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-gold mb-2" data-id="element-31">
            🎁 5 Bonus — Kostenlos enthalten
          </h2>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-32">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white/10 border border-brand-gold/30 p-4 sm:p-5 rounded-xl backdrop-blur-sm" data-id="element-33">
              <div className="flex items-center gap-2 mb-2" data-id="element-34">
                <span className="text-brand-gold font-black text-xs tracking-widest" data-id="element-35">
                  BONUS {bonus.num}
                </span>
                <span className="text-white/30" data-id="element-36">|</span>
                <span className="text-xs font-black text-brand-gold uppercase" data-id="element-37">
                  Wert {bonus.value} — KOSTENLOS
                </span>
              </div>
              <h3 className="text-sm sm:text-base font-bold text-white leading-tight mb-1" data-id="element-38">
                {bonus.title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-300 font-medium leading-snug" data-id="element-39">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}